import {gsap} from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger)



function scrollFade(){
    gsap.from("#about",{
        scrollTrigger:{
            trigger:"#about",
            toggleActions:"play pause none none",
        },
        y:100,
        ease: "power1.inOut",
        opacity:0,
    })
    gsap.from("#speaker",{
        scrollTrigger:{
            trigger:"#speaker",
            toggleActions:"play pause none none",
        },
        y:100,
        opacity:0,
    })
    gsap.from("#timetable",{
        scrollTrigger:{
            trigger:"#timetable",
            toggleActions:"play pause none none",
        },
        y:100,
        opacity:0,
    })
    gsap.from("#overview",{
        scrollTrigger:{
            trigger:"#overview",
            toggleActions:"play pause none none",
        },
        y:100,
        opacity:0,
    })
    gsap.from("#faq",{
        scrollTrigger:{
            trigger:"#faq",
            toggleActions:"play pause none none",
        },
        y:100,
        opacity:0,
    })
}

export default scrollFade
